import React from "react";
import DataTable from "react-data-table-component";
import "../../../assets/sass/admin/Coupon/ShowCoupon.scss";
import { get, Delete } from "../../../utills/API";
import { Link } from "react-router-dom";
import DeleteRedeemBrandCoupon from "./DeleteRedeemBrandCoupon";

class ShowCoupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          name: "S.No.",
          selector: "id",
          sortable: true
        },
        {
          name: "Brand Name",
          selector: "brand_name",
          sortable: true
        },
        {
          name: "Guid",
          selector: "guid",
          sortable: true
        },
        {
          name: "Amount",
          selector: "amount",
          sortable: true
        },
        {
          name: "Edit",
          button: true,
          cell: row => (
            <Link to={`/admin/redeemBrandCoupon/${row.id}/edit`}>
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </Link>
          )
        },
        {
          name: "Delete",
          button: true,
          cell: row => (
            <a onClick={() => this.showDeleteModal(row.id)}>
              <i class="far fa-trash-alt"></i>
            </a>
          )
        }
      ],
      filterText: "",
      resetPaginationToggle: false,
      brandCoupons: [],
      showDeleteModal: false,
      brandCouponId: "",
      isLoad: false
    };
  }

  showDeleteModal = id => {
    this.setState({
      showDeleteModal: true,
      brandCouponId: id
    });
  };

  closeDeleteModal = () => {
    this.setState({
      showDeleteModal: false
    });
  };

  deleteBrandCoupon = async Id => {
    try {
      const { data } = await Delete(`reedem_brand_coupons/${Id}`);
      this.setState({ showDeleteModal: false, isLoad: !this.state.isLoad });
    } catch (e) {
      console.log("error", e);
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.isLoad !== this.state.isLoad) {
      try {
        const { data } = await get("reedem_brand_coupons");
        var brandCoupons = data.data.reedem_brand_coupons;
      } catch (e) {
        console.log("error", e);
      }

      this.setState({ brandCoupons });
    }
  }

  async componentDidMount() {
    try {
      const { data } = await get("reedem_brand_coupons");
      var brandCoupons = data.data.reedem_brand_coupons;
    } catch (e) {
      console.log("error", e);
    }

    this.setState({ brandCoupons });
  }

  searchHeader = e => {
    console.log("event", e);
  };

  onFilter = e => {
    this.setState({ filterText: e.target.value });
  };

  onClear = () => {
    this.setState({ filterText: "" });
  };

  render() {
    const { brandCoupons, columns, filterText } = this.state;
    const filteredItems = brandCoupons.filter(item =>
      item.brand_name.toLowerCase().includes(filterText.toLowerCase())
    );
    return (
      <div className="span9 brand-coupon">
        <div className="row-fluid">
          <div className="block">
            <div className="navbar navbar-inner block-header">
              <div className="muted pull-left">Show Redeem Brand Coupons</div>

              <div className="muted pull-right">
                <Link
                  className="btn btn-primary delete"
                  to={"/admin/redeemBrandCoupon/new"}
                >
                  Add Coupons
                </Link>
              </div>
            </div>

            <div className="block-content  in">
              <div className="span12" style={{ marginLeft: "0" }}>
                <div className="">
                  <DataTable
                    subHeader
                    subHeaderComponent={
                      <FilterComponent
                        onFilter={this.onFilter}
                        onClear={this.onClear}
                        filterText={filterText}
                      />
                    }
                    columns={columns}
                    pagination={true}
                    //persistTableHead
                    data={filteredItems}
                  />
                  <DeleteRedeemBrandCoupon
                    state={this.state}
                    showDeleteModal={this.showDeleteModal}
                    closeDeleteModal={this.closeDeleteModal}
                    deleteBrandCoupon={this.deleteBrandCoupon}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const FilterComponent = props => {
  return (
    <div className="row filterComp">
      <div className="filterComp-input">
        <input
          className="form-control"
          type="text"
          placeholder="Filter By Name"
          value={props.filterText}
          onChange={props.onFilter}
        />
      </div>

      <button onClick={props.onClear}>X</button>
    </div>
  );
};

export default ShowCoupon;
